import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { BhuArt } from "@/components/BhuArt";
import { MAIN_REGISTRATION_FORM } from "@/data/eventData";

const FinalCTA = () => (
    <section
        data-testid="final-cta-section"
        className="relative flex min-h-[85svh] flex-col items-start justify-center overflow-hidden py-28"
    >
        <div aria-hidden="true" className="absolute inset-0 opacity-60">
            <BhuArt className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-ink/70" />
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_70%_60%_at_50%_100%,rgba(201,31,38,0.25),transparent_65%)]" />
        </div>
        <div aria-hidden="true" className="absolute -left-40 top-1/2 hidden -translate-y-1/2 lg:block">
            <svg width="480" height="480" viewBox="0 0 480 480" fill="none">
                <circle cx="240" cy="240" r="238" stroke="#C91F26" strokeOpacity="0.2" />
                <circle cx="240" cy="240" r="180" stroke="#C91F26" strokeOpacity="0.12" />
            </svg>
        </div>

        <div className="relative z-10 mx-auto w-full max-w-[1400px] px-5 md:px-10">
            <Reveal>
                <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.45em] text-scarlet">
                    I-ACE Chapter 4
                </p>
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="mt-8 font-serif text-[13vw] font-light leading-[0.95] tracking-tight text-cream sm:text-7xl lg:text-8xl">
                    Ready to make
                    <br />
                    an <em className="italic text-scarlet">Impact?</em>
                </h2>
            </Reveal>
            <Reveal delay={0.2}>
                <p className="mt-8 max-w-md text-base font-light leading-relaxed text-ash md:text-lg">
                    Be a part of I-ACE Chapter 4.
                </p>
            </Reveal>
            <Reveal delay={0.3}>
                <a
                    href={MAIN_REGISTRATION_FORM}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="final-register-btn"
                    className="group mt-10 inline-flex w-full items-center justify-center gap-3 bg-crimson px-10 py-5 font-sans text-xs font-semibold uppercase tracking-[0.25em] text-cream transition-colors duration-300 hover:bg-scarlet sm:w-auto"
                >
                    Register Now
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
                </a>
            </Reveal>
        </div>
    </section>
);

export default FinalCTA;
